import { render, staticRenderFns } from "./RecipientsTable.vue?vue&type=template&id=6f5621cb"
import script from "./RecipientsTable.vue?vue&type=script&lang=ts"
export * from "./RecipientsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports